import { render, staticRenderFns } from "./QueryCreator.vue?vue&type=template&id=0fd4f72a&"
import script from "./QueryCreator.vue?vue&type=script&lang=ts&"
export * from "./QueryCreator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports